import type { IconSvgObject } from './types';

const MoreIcon: IconSvgObject = [
  ["path", { d: "M2 15C2 14.4477 2.44772 14 3 14H8C8.55228 14 9 14.4477 9 15V20C9 20.5523 8.55228 21 8 21H3C2.44772 21 2 20.5523 2 20V15Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 15C15 14.4477 15.4477 14 16 14H21C21.5523 14 22 14.4477 22 15V20C22 20.5523 21.5523 21 21 21H16C15.4477 21 15 20.5523 15 20V15Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 4C8.5 3.44772 8.94772 3 9.5 3H14.5C15.0523 3 15.5 3.44772 15.5 4V9C15.5 9.55228 15.0523 10 14.5 10H9.5C8.94772 10 8.5 9.55228 8.5 9V4Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MoreIcon;
